import { render, staticRenderFns } from "./CustomPayment-95.vue?vue&type=template&id=531bbd22&scoped=true&"
import script from "./CustomPayment-95.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-95.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-95.vue?vue&type=style&index=0&id=531bbd22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531bbd22",
  null
  
)

export default component.exports